module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "in_head"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LIST OF ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "sub_"
  }, [_vm._v("Most frequently used abbreviations (Railway Companies).")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BR")]), _vm._v(" = British Railways. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("GWR")]), _vm._v(" = Great Western Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LMS")]), _vm._v(" = London, Midland and Scottish (Railway). "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LNER")]), _vm._v(" = London and North Eastern Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SR =")]), _vm._v(" Southern Railway.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_"
  }, [_vm._v("Other abbreviations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CR")]), _vm._v(" = Caledonian Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("GCR =")]), _vm._v(" Great Central Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("GNR =")]), _vm._v(" Great Northern Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("IOW")]), _vm._v(" = Isle of Wight (railway). "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LYR")]), _vm._v(" = Lancashire and Yorkshire Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LBSCR")]), _vm._v(" = London, Brighton and South Coast Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LNWR")]), _vm._v(" = London and North Western Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LSWR")]), _vm._v(" = London and South Western Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MR")]), _vm._v(" = Midland Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("NBR")]), _vm._v(" = North British Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("NER")]), _vm._v(" = North Eastern Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SDR (SDJR)")]), _vm._v(" = Somerset and Dorset (Joint) Railway. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("SEC")]), _vm._v(" = South East and Chatham Railway.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_"
  }, [_vm._v("Types of tank locomotive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")]), _vm._v(" = Tank locomotive (ordinary).")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PT =")]), _vm._v(" Pannier Tank locomotive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ST")]), _vm._v(" = Saddle Tank locomotive.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_"
  }, [_vm._v("Class of locomotive")]), _vm._v(" "), _c('p', {
    staticClass: "sub_1"
  }, [_vm._v("(Southern Railway locomotives).")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BB")]), _vm._v(" = Battle of Britain Class. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("LN")]), _vm._v(" = Lord Nelson Class. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MN")]), _vm._v(" = Merchant Navy Class. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("WC")]), _vm._v(" = West Country Class.")]), _vm._v(" "), _c('p', {
    staticClass: "sub_"
  }, [_vm._v("Locomotive Power Classification (BR System).")]), _vm._v(" "), _c('p', {
    staticClass: "indent_"
  }, [_vm._v("British Railways used a universal power classification for locomotives, derived from their pulling power and speed ratio. The system adopted by BR in 1948 was based on a slightly modified numbering system which had been used by the LMS (and Midland Railway), whereby the various types (classes) of locomotive were given a power classification number, ranging from zero to eight ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("0")]), _vm._v("-"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _vm._v(") for passenger locomotives and zero to nine ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("0-9)")]), _vm._v(" for freight locomotives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Zero was regarded as the least powerful locomotive and nine was the most powerful. The number was painted on the side of the cab, together with a suffix, letter "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘P’")]), _vm._v(" or "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘F’")]), _vm._v(", which denoted whether the locomotive was designed for passenger or freight work. For example; ‘"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("8P’")]), _vm._v(" denoted the most powerful express passenger locomotives whilst ‘"), _c('span', {
    staticClass: "bold"
  }, [_vm._v("9F’")]), _vm._v(" was awarded to the most powerful class of freight locomotives (freight locomotives included shunting and banking engines). Locomotives classified as "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘0F’")]), _vm._v(" or "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘1F’")]), _vm._v(" would usually indicate a small shunting engine, whilst "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘5P’")]), _vm._v(" would be allocated to a standard passenger locomotive. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘3F’")]), _vm._v(" would indicate a light freight / goods locomotive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A locomotive designed for both passenger and freight work was known as a mixed traffic locomotive ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MT")]), _vm._v("). These locomotives either displayed two power classification numbers with the letter "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘P’")]), _vm._v(" rating first, followed by the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘F’")]), _vm._v(" rating (example "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("6P5F")]), _vm._v(") or if the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘P’")]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("‘F’")]), _vm._v(" ratings were the same they were given a single ‘mixed traffic’ ("), _c('span', {
    staticClass: "bold"
  }, [_vm._v("MT")]), _vm._v(") rating (example "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("5MT")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "sub_"
  }, [_vm._v("Other abbreviations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WD")]), _vm._v(" = War Department. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ROD")]), _vm._v(" = Railway Operating Division. Locomotives used for wartime service were under the control of the British Army, Royal Engineers, Railway Operating Division, or "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("ROD.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270ef2c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/007_List_of_Abbreviations.vue
// module id = 75
// module chunks = 0